const getGenderPref = (departmentName, genderPref) => ((departmentName && [`gender:(${departmentName})`]) || (genderPref?.length > 0 && genderPref) || []);

export default getGenderPref;
